import axios from 'axios';

import { getAdmin } from './admin';
import {
  ROOT,
  SET_LAST_ACTIVE,
  LOGIN_URL,
  SET_TOKEN,
  SET_ERROR,
  REFRESH_TOKEN_URL,
  SET_LAST_REFRESHED,
  SET_IS_REFRESHING,
  USERS_URL,
  RESET_PASSWORD_URL,
  PASSWORD_URL,
  RESET_PASSWORD_LINK_URL,
  SET_NEW_PIN,
  SET_CURRENT_USER,
  PROFILE_URL,
  ADMIN_URL,
  SET_LAST_CLICKED,
} from '../../constants';

export const login = (payload) => {
  return async (dispatch) => {
    axios
      .post(`${ROOT}${LOGIN_URL}`, payload)
      .then((response) => {
        const { token } = response.data;
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('sso', JSON.stringify(false));
        dispatch(setToken(token));
        dispatch(setError(null));
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response;
        dispatch(setError(data));
      });
  };
};

export const logout = () => {
  return async (dispatch) => {
    sessionStorage.removeItem('token');
    dispatch(setToken(null));
  };
};

export const register = (payload) => {
  return async (dispatch) => {
    axios
      .post(`${ROOT}${USERS_URL}`, payload)
      .then((response) => {
        const { token } = response.data;
        sessionStorage.setItem('token', token);
        dispatch(setToken(token));
        dispatch(setError(null));
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response;
        dispatch(setError(data));
      });
  };
};

export const refreshToken = (token) => {
  return async (dispatch) => {
    axios
      .post(`${ROOT}${REFRESH_TOKEN_URL}`, { token })
      .then((response) => {
        if (!response) {
          dispatch(logout());
          setIsRefreshing(false);
        }
        const newToken = response.data.token;
        sessionStorage.setItem('token', newToken);
        dispatch(setToken(newToken));
        dispatch(setLastRefreshed(new Date()));
        setIsRefreshing(false);
      })
      .catch(() => {
        dispatch(logout());
        setIsRefreshing(false);
      });
  };
};

export const ssoToken = (token) => {
  return async (dispatch) => {
    dispatch(setToken(token));
    dispatch(refreshToken(token));
    sessionStorage.setItem('sso', JSON.stringify(true));
    dispatch(setLastRefreshed(new Date()));
    setIsRefreshing(false);
  };
};

export const forgotPassword = (email) => {
  return async (dispatch) => {
    axios.post(`${ROOT}${RESET_PASSWORD_LINK_URL}`, { email }).catch((error) => {
      const { response } = error;
      const { data } = response;
      dispatch(setError(data));
    });
  };
};

export const resetPassword = (payload, history) => {
  return async (dispatch) => {
    axios
      .post(`${ROOT}${RESET_PASSWORD_URL}`, payload)
      .then(() => {
        history.push('../');
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response;
        dispatch(setError(data));
      });
  };
};

export const editPassword = (payload, history) => {
  return async (dispatch) => {
    axios
      .post(`${ROOT}${PASSWORD_URL}`, payload)
      .then(() => {
        history.push('');
      })
      .catch((error) => {
        const { response } = error;
        const { data } = response;
        dispatch(setError(data));
      });
  };
};

export const setNewPin = (payload) => {
  return async (dispatch) => {
    axios.post(`${ROOT}${SET_NEW_PIN}`, payload).catch((error) => {
      const { response } = error;
      const { data } = response;
      dispatch(setError(data));
    });
  };
};

export const getCurrentUser = () => {
  return async (dispatch) => {
    axios
      .get(`${ROOT}${PROFILE_URL}`)
      .then((response) => {
        const match = response.data;
        dispatch(setCurrentUser(match));
      })
      .catch((error) => {
        let data = [];
        if (error.response) {
          const { response } = error;
          data = response.data;
        }
        return { success: false, data };
      });
  };
};

export const editUser = (formData, id, setCurrent = true) => {
  return async (dispatch) => {
    axios
      .patch(`${ROOT}${ADMIN_URL}${id}/`, formData)
      .then((response) => {
        const match = response.data;
        if (setCurrent) dispatch(setCurrentUser(match));
        else dispatch(getAdmin());
        return match;
      })
      .catch((error) => {
        return error;
      });
  };
};

export const setToken = (token) => {
  return {
    type: SET_TOKEN,
    token,
  };
};

export const setError = (error) => {
  return {
    type: SET_ERROR,
    error,
  };
};

export const setLastActive = (lastActive) => {
  return {
    type: SET_LAST_ACTIVE,
    lastActive,
  };
};

export const setLastRefreshed = (lastRefreshed) => {
  return {
    type: SET_LAST_REFRESHED,
    lastRefreshed,
  };
};

export const setIsRefreshing = (isRefreshing) => {
  return {
    type: SET_IS_REFRESHING,
    isRefreshing,
  };
};

export const setCurrentUser = (user) => {
  return {
    type: SET_CURRENT_USER,
    user,
  };
};

export const setLastClicked = (time) => {
  return {
    type: SET_LAST_CLICKED,
    time,
  };
};
